var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeDetalhamentoConsumo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M10 0C4.4771576 0 0 4.47717285 0 10s4.4771576 10 10 10 10-4.47717285 10-10S15.5228424 0 10 0zM2 10c0 4.41827393 3.58172607 8 8 8s8-3.58172607 8-8-3.58172607-8-8-8-8 3.58172607-8 8zm12.23999023-4.23999023C13.11747742 4.63201904 11.59132385 3.99853516 10 4v6l-4.2400055 4.23999023c1.49575806 1.60522461 3.74844361 2.26599122 5.87431336 1.7230835 2.12586975-.54290771 3.78585816-2.20288086 4.32876587-4.32873535.54290772-2.12591553-.11785889-4.37860108-1.7230835-5.87432861z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeDetalhamentoConsumo);
export default __webpack_public_path__ + "static/media/icone-detalhamento-consumo.0b59979f949cb88e9459a2debf9da697.svg";
export { ForwardRef as ReactComponent };